"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobile_detection_1 = require("../../reverb-js-common/mobile_detection");
var lodash_1 = require("lodash");
var BLANK_MEDIUM_IMAGE = require('../../../images/products/blank_medium.jpg');
var DIGITAL_LISTING_UUID = 'e71b6e43-7217-4746-b4e3-64bf708a2664';
var Listing = /** @class */ (function () {
    function Listing(listingJSON) {
        Object.assign(this, listingJSON);
    }
    Listing.prototype.link = function (name) {
        return lodash_1.get(this._links, name + ".href");
    };
    Object.defineProperty(Listing.prototype, "largeImage", {
        get: function () {
            if (this.photos.length === 0) {
                return BLANK_MEDIUM_IMAGE;
            }
            if (mobile_detection_1.default.isMobileBrowser()) {
                return this.photos[0]._links.mobile_small.href;
            }
            return this.photos[0]._links.medium_square.href;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Listing.prototype, "smallCropImage", {
        get: function () {
            if (this.photos.length === 0) {
                return BLANK_MEDIUM_IMAGE;
            }
            return this.photos[0]._links.small_crop.href;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Listing.prototype, "bumpClickTrackingHref", {
        get: function () {
            if (!this.bumped || !this._links.track_click) {
                return;
            }
            return this._links.track_click.href;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Listing.prototype, "closed", {
        get: function () {
            return this.state.slug !== 'live';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Listing.prototype, "isDigitalListing", {
        get: function () {
            return this.category_uuids.includes(DIGITAL_LISTING_UUID);
        },
        enumerable: true,
        configurable: true
    });
    return Listing;
}());
exports.default = Listing;
//# sourceMappingURL=listing.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/listing.js
// module id = TZ2L
// module chunks = 20 21